import { prepareMutiLineText } from "@shared/utils";
import { DefaultSelection36RfiFlowPayload, DefaultSelection36RfiRecallPayload } from "../api-generated";
import LocalContractUserService from "@services/local-contractUser.service";
export default class RecallHistoryTableItem
{
  public Sequence: number;
  public Status: string;
  public RequestedBy: string;
  public RequestedOn: string;
  public ReviewedBy: string;
  public ReviewedOn: string;
  public Note: string;
  public Collapse: boolean;
  
  constructor(item: DefaultSelection36RfiRecallPayload, localContractUserService: LocalContractUserService, flows: DefaultSelection36RfiFlowPayload[], index: number) {
    this.Sequence = index + 1;
    const requestedBy = localContractUserService.getUserInfo(item.CreatedBy);
    if(requestedBy)
    {
      const role = localContractUserService.getUserRole(item.CreatedBy);
      this.RequestedBy = `${requestedBy.displayName ?? ""} (${role ?? ""})`;
    }
    else {
      this.RequestedBy = "N/A";
    }
    this.RequestedOn = item.DateCreated ? this.getFormatedDateAndTime(item.DateCreated) : "N/A";
    const recallItemIndex = flows.findIndex((flow)=>{return flow.DateReceived === item.DateCreated});
    if(recallItemIndex && recallItemIndex !== 0 && recallItemIndex !== flows.length - 1)
    {
      const before = flows[recallItemIndex - 1];
      const after  = flows[recallItemIndex + 1];
      const reviewedBy = localContractUserService.getUserInfo(after.SubmittedBy);
      this.Status = before.Status === after.Status ? 'Rejected' : 'Accepted';
      if(reviewedBy)
      {
        const role = localContractUserService.getUserRole(after.SubmittedBy);
        this.ReviewedBy = `${reviewedBy.displayName ?? ""} (${role ?? ""})`;
      }
      else {
        this.ReviewedBy = "N/A";
      }
      this.ReviewedOn = after.DateReceived ? this.getFormatedDateAndTime(after.DateReceived) : "N/A";
    }
    this.Note = item.Notes ? prepareMutiLineText(item.Notes) : "N/A";
    this.Collapse = true;
  }



  private getFormatedDateAndTime(date: string): string {
    return `${new Date(date)
      .toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric"
      })
      .replace(", ", "/")
      .replace(" ", "/")} ${new Date(date).toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit"
    })}`;
  }
}
